import axios from 'axios';
import { getToken } from './getToken';

// In Node/Vitest, axios' HTTP adapter requires an absolute base URL.
// In the browser we keep the original relative base '/'.
const isNodeEnv = typeof window === 'undefined';
const baseURL = isNodeEnv ? 'http://localhost' : '/';

export const axiosInstance = axios.create({
  baseURL,
});

// Use the stored token in the interceptor instead of the hook
axiosInstance.interceptors.request.use(async (config) => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('token set\n');
  }

  return config;
});

export default axiosInstance;
